@import '@wandb/weave/common/css/globals.less';

.create-report-prompt-tooltip {
  &&&&& {
    background-color: light-dark(@gray800, var(--moon-100));
    padding: 24px;
    border-radius: 5px;
    &:before {
      background-color: light-dark(@gray800, var(--moon-100));
    }
  }
}
